import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AssetPageModule } from '@components/asset/asset.module';
import { ListSkeletonPageModule } from '@components/list-skeleton/list-skeleton.module';

import { UserSelectModalPage } from './user-select-modal.page';
import { PipesModule } from '@pipes/pipes.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        PipesModule,
        AssetPageModule,
        ListSkeletonPageModule
    ],
    declarations: [UserSelectModalPage],
    exports: [UserSelectModalPage]
})
export class UserSelectModalPageModule { }
